module.exports = __webpack_public_path__ + "img/ado.961b50b6.png";